module.exports = __webpack_public_path__ + "img/vehicle-aprilia.dc988a89.png";